import React, { Component } from 'react'
import Link from 'next/link'

import moment from 'moment-business-days';
import _ from 'lodash'
import { trackAnalyticsCommerceEvent } from '../../Utils/AnalyticsUtils';

import DisplayAmount from '../common/DisplayAmount';
import AppointmentFormCart from '../appointments/AppointmentFormCart';
import DisplayStock from "../common/DisplayStock";
import getConfig from "next/config";
import { connect } from 'react-redux';
import { withTranslation, Trans } from 'react-i18next';
import { simpleDateTimeFormat } from '../../lib/DateFormat';
import { getUniqueID } from '../../lib/CatalogUtils';
import { getRolename } from '../../lib/AuthUtils'
import { ROLES } from '../../constants/AuthConstants';
import {
  BookOutlined,
  CheckCircleFilled,
  CheckCircleOutlined,
  CloseCircleFilled,
  CloseOutlined,
  DeleteFilled,
  PercentageOutlined,
  PlusOutlined,
  PrinterOutlined,
  ShoppingCartOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import {
  Input,
  Select,
  InputNumber,
  Row,
  Col,
  Button,
  Table,
  notification,
  Modal,
  Tooltip,
  message,
  Divider,
  Form
} from 'antd';
import {
  setShowQuickCart,
  getCurrentOrder,
  removeItemFromOrder,
  changeItemQuantityFromOrder,
  setDataToOrder,
  saveOrder,
  cancelOrder,
  confirmOrder,
  closeConfirmationCompleteDialog,
  autocompleteMyClients,
  addClientToOrder,
  addItemToOrderFromCode,
  searchTransports,
  addTransportToOrder,
  showItemDetail,
  getProductByCode,
  getMyAppointments
} from '../../actions'

const FormItem = Form.Item;
const { TextArea } = Input;
const Option = Select.Option;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 7 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 17 },
  },
};

// prefix string to form the i18n key
const I18N_PREFIX = 'APPOINTMENT_';

// maxLength for observations
const OBSERVATION_LENGTH = getConfig().publicRuntimeConfig.observationLength;

class CatalogQuickCartForm extends Component {

  constructor(props) {
    super(props);

    const rolename = getRolename(this.props.auth);
    this.formRef = React.createRef();
    this.inputProductCode = React.createRef();

    this.state = {
      itemCode: '',
      canItem: 1,
      item: null,
      selectTypeAppointment: rolename === ROLES.SALESMAN ? 'Create' : null,
      appointment_event: null,
      appointmentDate: moment(),
      start_dateTime: null,
      commentary: null,
      collection: false,
      detail: null,
      errors: {},
      appointmentSelectedId: null,
      isSalesman: rolename === ROLES.SALESMAN,
      confirmAppointmentModal: false,
      confirmOrderModal: false
    }
  }

  componentDidMount() {
    const { currentAddSuccess } = this.props;
    if (!currentAddSuccess) {
      this.props.getCurrentOrder();
    }
  }

  componentDidUpdate(prevProps) {

    if (prevProps.product === null && prevProps.product !== this.props.product) {
      const payload = {
        show: true,
        action: 'view',
        item: { parent: 'cart',data_cart: this.state.item, ...this.props.product } // This is the product added to cart
      };
      this.props.showItemDetail(payload)
    }
    if (!this.props.order) {
      this.props.getCurrentOrder();
    }

    if (this.props.confirmationStatus) {
      const { t, confirmationStatus } = this.props;
      const iconSuccess = <CheckCircleOutlined style={{ color: 'green' }} />;
      const iconWarning = <WarningOutlined style={{ color: 'orange' }} />;
      const messageSuccess = t('Successful Confirmation');
      const messageWarning = t('Confirmed with errors');
      const descriptionSuccess = t('Order confirmed successfully');
      const descriptionWarningUnKnowProblem = t('Order was saved and confirmed but there was a problem with the app', { orderId: confirmationStatus.idPedido });
      const descriptionWarningErrorEvent = t('Order was saved and confirmed but there was a problem with the event', { orderId: confirmationStatus.idPedido });

      let config = {duration: 4};
      if (confirmationStatus.success) {
        if (confirmationStatus.errorOnSaveEvent) {
          config.message = messageWarning
          config.description = descriptionWarningErrorEvent;
          config.icon = iconWarning;
        } else {
          config.message = messageSuccess
          config.description = descriptionSuccess;
          config.icon = iconSuccess;
        }
      } else {
        config.message = messageWarning
        config.description = descriptionWarningUnKnowProblem;
        config.icon = iconWarning;
      }

      notification.open(config);
      this.props.closeConfirmationCompleteDialog();
    }

    if (this.props.order && this.props.order.transporteId) {
      this.formRef.current.setFieldsValue({ transport: this.props.order.transporteId })
    }

    if(prevProps.loading !== this.props.loading && this.props.loading === false) {
      this.state.isSalesman ? this.handleConfirmAppointmentModalClose() : this.cancelConfirmIntention()
    }

  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const updatedState = {};

    Object.keys(nextProps).forEach(key => {
      if (prevState[key] !== nextProps[key]) {
        updatedState[key] = nextProps[key];
      }
    });

    if (Object.keys(updatedState).length === 0) {
      return null;
    }

    return updatedState;
  }

  columns = [
    {
      title: false,
      dataIndex: '',
      key: 'icons',
      render: (tex, record) => (
          <table className="cart-item-table">
            {record.index === 0 && (
                <thead>
                <tr className="text-center">
                  <th>
                    <Trans>Code</Trans>
                  </th>
                  <th>
                    <Trans>Stock</Trans>
                  </th>
                  <th>
                    <Trans>Cant.</Trans>
                  </th>
                  <th>Detalle</th>
                  <th>
                    <Trans>Price</Trans>
                  </th>
                  <th/>
                </tr>
                </thead>
            )}
            <tbody>
              <tr className="text-center">
                <td width={60}>
                  <div className="catalog-item-card-title" onClick={() => this.showDetail({ ...record })}>
                    <p><a>{record.codigodearticulo}</a></p>
                  </div>
                </td>
                <td width={60}>
                  <DisplayStock product={record} />
                </td>
                <td width={80}>
                  <InputNumber
                      step={(record.multiplo) ? record.multiplo : 1}
                      min={(record.cantidadminima) ? record.cantidadminima : 1}
                      maxLength='6'
                      value={record.cantidad}
                      onChange={(value) => this.onChangeQty(record, value)}
                      onKeyDown={function (e) {
                        const regex = /^[0-9]{0,6}$/;
                        if (!regex.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                  />
                </td>
                <td width={70}>
                  <Tooltip title={this.renderDiscount(record.descuento)}>
                    <PercentageOutlined />
                  </Tooltip>
                  <Divider type={'vertical'} />

                  {record.observaciones && <Tooltip title={record.observaciones}>
                    <BookOutlined />
                  </Tooltip>}
                </td>
                <td width={100}>
                  <DisplayAmount amount={record.precioFinal} currency={record.moneda} />
                </td>
                <td width={40} rowSpan={1}>
                  <a style={{paddingBottom: 50}}  onClick={() => { this.onRemoveItem(record) }}>
                    <Tooltip title={<Trans>Remove product</Trans>}>
                      <DeleteFilled />
                    </Tooltip>
                  </a>
                </td>
              </tr>
              <tr>
                <td colSpan={6}>{record.descripcion}</td>
              </tr>
            </tbody>
          </table>
      )
    }
  ];

  renderDiscount = (descuentos) => {
    let result = ''
    // Check if descuentos is not null (offline)
    if (descuentos) {
      descuentos.forEach(descuento => {
        const tmpdesc = descuento.replace(/(\.\d{2})\d*/, "$1");
        result = (result == '') ? tmpdesc : result.concat(', ', tmpdesc);
      });
    }
    return result;
  }

  showDetail(data) {
    this.setState({ item: data });
    this.props.getProductByCode({ codigodearticulo: data.codigodearticulo })
  }

  onClose = () => {
    // showCategories
    this.props.setShowQuickCart(false);
  }

  onRemoveItem = (item) => {
    this.props.removeItemFromOrder({
      orderId: this.props.order.id,
      orderUpdatedAt: this.props.order.updatedAt,
      itemCode: item.codigodearticulo
    })
  }

  onInputChange = (type, value) => {
    let newState = { ... this.state }

    newState.order[type] = value;
    this.setState(newState)

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    this.typingTimeout = setTimeout(() => {
      this.props.setDataToOrder({
        orderId: this.props.order.id,
        type,
        value,
        orderUpdatedAt: this.props.order.updatedAt
      })

    }, 500)
  }

  onChangeQty = (record, value) => {
    const { t } = this.props;

    const minimum = record.cantidadminima | 1
    const multi = record.multiplo | 1

    if (minimum > value) {
      if (value) message.error(t('quantity-min', { min: minimum }));
    } else if ((value % multi) > 0) {
      if (value) message.error(t('multiple-num', { cant: multi }));
    } else {
      this.props.changeItemQuantityFromOrder({
        orderId: this.props.order.id,
        itemCode: record.codigodearticulo,
        orderUpdatedAt: this.props.order.updatedAt,
        quantity: parseInt(value, 10)
      })
    }

  }

  onSave = () => {
    this.props.saveOrder({
      orderId: this.props.order.id,
    })
  }

  onDelete = () => {
    this.props.cancelOrder({
      orderId: this.props.order.id,
      orderUpdatedAt: this.props.order.updatedAt
    })
  }

  onConfirmIntention = () => {
    this.setState({confirmOrderModal: true});
  }

  cancelConfirmIntention = () => {
    this.setState({confirmOrderModal: false});
  }

  onConfirmCreateAppointment = () => {
    this.setState({confirmAppointmentModal:true})
  };

  handleConfirmAppointmentModalClose = () => {
    this.setState({
      confirmAppointmentModal:false,
      collection: false,
      detail: null,
      errors: {},
      start_dateTime: null
    });
  };

  handleSetStateAppointmentChange = (key,value) => {
    const newState = key === 'selectTypeAppointment' ? { [key]: value, appointment_event: null } : { [key]: value };
    this.setState(newState);
  };

  onDeleteIntention = () => {
    const { t } = this.props;
    Modal.confirm({
      iconType: 'exclamation-circle',
      title: t('Delete order'),
      content: t('Do you wish to delete the order?'),
      okText: t('Confirm'),
      cancelText: t('Cancel'),
      onOk: this.onDelete
    });
  }

  validateForm = () => {
    const { t } = this.props;
    const { detail, collection } = this.state;
    const errors = {};
    let hasError = false;

    if((!detail || detail === "") && collection) {
      errors.detail = t('validation-required', { field: t('Details') });
      hasError = true;
    }

    hasError ? this.setState({ errors }) : this.onConfirm();
  }

  onConfirm = () => {
    const { t, order, confirmOrder } = this.props;
    const { appointmentSelectedId, appointment_event, commentary, appointmentDate, collection, detail } = this.state;

    const baseDate = moment(appointmentDate);
    const startDateTime = moment(this.state.start_dateTime).year(baseDate.year()).month(baseDate.month()).date(baseDate.date());
    const endDateTime = moment(startDateTime).add(30, 'minutes');

    const appointmentSelected = appointmentSelectedId ? _.filter(this.props.appointmentList, appointment => { return appointment.id === appointmentSelectedId }) : [];
    const note = commentary || t('EVENT_CREATION_NOTE');

    let appointment = appointmentSelected[0] ? appointmentSelected[0].data :
        {
          title: t('Generate Order'),
          start_dateTime: startDateTime,
          end_dateTime: endDateTime,
          actions: [],
          appointment_state: "concluded",
          appointment_event,
          appointmentClientId: order.clienteId,
          notes: [
            {
              id: getUniqueID(),
              date: moment().format(simpleDateTimeFormat),
              note,
            }
          ],
        };

    let action = collection ?
        {
          id: getUniqueID(),
          action: "collection",
          detail
        } :
        {
          id: getUniqueID(),
          action: "order",
          detail: t('appointment_noDetail')
        };

    appointment.actions.push(action);

    const orderToSave = {
      orderId: order.id,
      orderUpdatedAt:order.updatedAt,
      appointment
    }

    this.sendPurchaseToGA(order);
    confirmOrder(orderToSave);
  }

  sendPurchaseToGA = (order) => {
    const items = order.productos.map(producto => ({
      item_id: producto.codigodearticulo,
      item_name: producto.descripcion,
      quantity: producto.cantidad,
      price: producto.precio,
      final_price: producto.precioFinal
    }));

    const total = items.reduce((sum, item) => sum + item.final_price, 0);

    trackAnalyticsCommerceEvent(
      "purchase", // event name
      "Order", // event category
      "Order Confirmed", // event label
      null,
      total,
      items // products added
    );
  }

  handleAutompleteChange = (query) => {
    const searchParams = { filtro: query, include: "transporte" };
    this.props.autocompleteMyClients(searchParams);
  }

  onSetClient = (client) => {
    const clientId = (client) ? client.id : '';

    if (client && client.transporte) {
      this.formRef.current.setFieldsValue({
          transporte: this.buildTransportDescription(client.transporte),
      });
    }

    this.props.addClientToOrder({
      orderId: this.props.order.id,
      clientId
    })

  }

  onTypeItemCode = (itemCode) => {
    this.setState({ itemCode })
  }

  onResetAppointmentId = () => {
    this.setState({appointmentSelectedId:null})
  }

  onAddItem = () => {
    if (this.state.itemCode) {

      this.props.addItemToOrderFromCode({
        orderId: this.props.order.id,
        orderUpdatedAt: this.props.order.updatedAt,
        quantity: this.state.canItem,
        code: this.state.itemCode
      })

      this.inputProductCode.current.focus();

      this.setState({ itemCode: '', canItem: 1 });

    }
  }

  onConfirmOrder = () => {
    const {t} = this.props
    const {order, isSalesman} = this.state

    if(!order.cliente) {
      return message.error(t("Order without client"))
    }

    if(!order.transporte) {
      return message.error(t("Order without transport"))
    }

    if(!order.productos || order.productos.length === 0) {
      return message.error(t("Order without product"))
    }

    return isSalesman ? this.onConfirmCreateAppointment() : this.onConfirmIntention()
  }

  handleTransportAutocompleteChange = (query) => {
    this.props.searchTransports({
      'filtro': query,
      'page': 1,
      'pageSize': 10
    });
  }

  onSetTransporte = (transport) => {
    const transportId = (transport) ? transport.id : ''
    this.props.addTransportToOrder({
      orderId: this.props.order.id,
      orderUpdatedAt: this.props.order.updatedAt,
      transportId
    })
  }

  buildTransportDescription(transport) {
    return `${transport.codigotransporte} - ${transport.descripcion}`
  }

  handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      this.onAddItem();
    }
  };

  handleObservationChange = (event) => {
    const {value} = event.target;
    if(value.length <= OBSERVATION_LENGTH) {
      this.onInputChange('observaciones', event.target.value)
    }
  }

  render() {
    const { clientsList, transportList, t, isMobile, loading } = this.props
    const { order, itemCode, canItem, isSalesman, errors, confirmAppointmentModal, start_dateTime, confirmOrderModal } = this.state

    const autocompleteClientDataSource = clientsList && clientsList.response && clientsList.response.data ? clientsList.response.data : [];

    // default transport value: order's transport, if already set
    const transport = order && order.transporte ? this.buildTransportDescription(order.transporte) : '';
    // if transport is already associated to the order and no search has been executed (first load), then initialize a datasource with the order's transport
    const autocompleteTransportDataSource = (transportList && transportList.data) ? transportList.data : order && order.transporte ? [order.transporte] : [];

    let qty = 0;
    let total = 0;

    const productsList = [];

    if (order) {
      for (let i = 0; i < order.productos.length; i++) {
        const item = order.productos[i];
        qty += item.cantidad;
        total += item.precioFinal;

        productsList[order.productos.length - i - 1] = {...item, index: order.productos.length - i - 1};
      }
    }

    // Build client name
    let clientName = ''
    if (order && order.cliente) {
      clientName = `${order.cliente.nombre} - ${order.cliente.fantasia}`
    }

    return (
      <div style={{minWidth:360}}>
        <Form ref={this.formRef}>
          {order &&
            <div>
              {isMobile && <Col span={24} style={{ textAlign: 'right', paddingRight: '10px' }} >
                <CloseOutlined onClick={this.onClose}/>
              </Col>}
              <div className="name-input">
                <FormItem {...formItemLayout} label="Referencia">
                  <Input onChange={(event) => this.onInputChange('referencia', event.target.value)} value={order.referencia} />
                </FormItem>
              </div>

              {isSalesman &&
                <div className="name-input">
                  <FormItem className='mt-3' {...formItemLayout} label="Cliente">
                    <Select
                      className="full-width"
                      defaultValue={clientName}
                      allowClear={true}
                      showSearch
                      optionFilterProp="children"
                      onSearch={this.handleAutompleteChange}
                      onChange={(record) => {
                        if (!record) {
                          this.onSetClient(null);
                        }
                      }}
                      onSelect={(record) => {
                        for (let index = 0; index < autocompleteClientDataSource.length; index++) {
                          if (autocompleteClientDataSource[index].codigocliente == record) {
                            const client = autocompleteClientDataSource[index];
                            this.onSetClient(client);
                          }
                        }
                      }}
                    >
                      {
                        autocompleteClientDataSource.map((client) => {
                          return <Option key={client.codigocliente}>{`${client.codigocliente} - ${client.nombre} - ${client.fantasia}`}</Option>;
                        })
                      }
                    </Select>
                  </FormItem>
                </div>
              }

              <div className="name-input">
                <FormItem
                  name="transporte"
                  className='mt-3'
                  {...formItemLayout}
                  label="Transporte"
                  initialValue={transport}
                  >
                  <Select
                      className="full-width"
                      allowClear={true}
                      showSearch
                      optionFilterProp="children"
                      onSearch={this.handleTransportAutocompleteChange}
                      onChange={(record) => {
                        if (!record) {
                          this.onSetTransporte(null);
                        }
                      }}
                      onSelect={(record) => {
                        for (let index = 0; index < autocompleteTransportDataSource.length; index++) {
                          if (autocompleteTransportDataSource[index].codigotransporte == record) {
                            const transport = autocompleteTransportDataSource[index];
                            this.onSetTransporte(transport);
                          }
                        }
                      }}
                    >
                      {
                        autocompleteTransportDataSource.map((transport) => {
                          return <Option key={transport.codigotransporte}>{this.buildTransportDescription(transport)}</Option>;
                        })
                      }
                  </Select>
                </FormItem>
              </div>

              <div className="name-input">
                <FormItem className='mt-3' {...formItemLayout} label="Producto">
                  <Row gutter={8}>
                    <Col span={14}>
                      <Input
                          ref={this.inputProductCode}
                          onChange={(event) => this.onTypeItemCode(event.target.value)}
                          value={itemCode}
                          onKeyDown={this.handleKeyDown}
                      />
                    </Col>
                    <Col span={6}>
                      <InputNumber
                          min={1}
                          value={canItem}
                          onChange={value => this.setState({ canItem: value })}
                          onKeyDown={this.handleKeyDown}
                      />
                    </Col>
                    <Col span={4}  >
                      <Button onClick={this.onAddItem}>
                        {<PlusOutlined />}
                      </Button>
                    </Col>
                  </Row>

                </FormItem>
              </div>

              <Table
                columns={this.columns}
                dataSource={productsList}
                className="quick-cart-table"
                locale={{
                  emptyText: t('No products'),
                }}
                rowKey={'codigodearticulo'}
                showHeader={false}
                pagination={{showSizeChanger: false}}
              />

              <div className="totals">
                <div>{t('Total units')}:&nbsp;{qty}</div>
                <div className='total-amount'>{t('Total')}:&nbsp;<DisplayAmount amount={total} /></div>
              </div>

              <div className="name-input" style={{ marginBottom: 10 }}>
                <TextArea
                  placeholder={t('Observations')}
                  rows={4}
                  onChange={this.handleObservationChange}
                  value={order.observaciones}
                />
                <p className='text-secondary text-right'>
                  {`${(order && order.observaciones) ? order.observaciones.length : 0}/${OBSERVATION_LENGTH}`}
                </p>
              </div>

              <div className="actions">
                <Tooltip title={t('Save and create new order')}>
                  <Button type="link" shape="circle" loading={false} onClick={this.onSave}>
                    <ShoppingCartOutlined style={{fontSize: 20}}/>
                  </Button>
                </Tooltip>
                <Tooltip title={t('Cancel order')}>
                  <Button type="link" shape="circle" loading={false} onClick={this.onDeleteIntention}>
                    <CloseCircleFilled style={{fontSize: 20}}/>
                  </Button>
                </Tooltip>
                <Tooltip title={t('Confirm order')}>
                  <Button type="link" shape="circle" disabled={false} size="default" onClick={this.onConfirmOrder}>
                    <CheckCircleFilled style={{fontSize: 20}}/>
                  </Button>
                </Tooltip>
                <Link href={{ pathname: '/catalog/printOrder', query: { id: order.id } }}>
                  <a target={'_blank'} >
                    <Tooltip title={t('Print view')}>
                      <Button type="link" shape="circle" loading={false}>
                        <PrinterOutlined style={{fontSize: 20}}/>
                      </Button>
                    </Tooltip>
                  </a>
                </Link>
              </div>
            </div>
          }
        </Form>
        <Modal
            title={ t('Appointment') }
            open={ confirmAppointmentModal }
            okText={ t('Confirm') }
            cancelText={ t('Cancel') }
            onOk={ this.validateForm }
            onCancel={ this.handleConfirmAppointmentModalClose }
            width={ 500 }
            cancelButtonProps={{
              disabled: loading,
            }}
            okButtonProps={{
              disabled: loading | !this.state.appointment_event,
              loading
            }}
        >
          <AppointmentFormCart
              t={t}
              order={order}
              isSalesman={isSalesman}
              start_dateTime={start_dateTime}
              errors={errors}
              handleSelectAppointmentId={this.onResetAppointmentId}
              handleSetStateChange={this.handleSetStateAppointmentChange}
          />
        </Modal>
        <Modal
            title={ t('Confirm order') }
            open={confirmOrderModal}
            okText={t('Confirm')}
            cancelText={t('Cancel')}
            closable={false}
            onOk={this.onConfirm}
            onCancel={this.cancelConfirmIntention}
            cancelButtonProps={{
              disabled: loading,
            }}
            okButtonProps={{
              disabled: loading,
              loading
            }}
        >
          <p>{t('Do you wish to confirm the order?')}</p>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = ({ appointment, catalog, orders, clients, auth, transports, products }) => {
  const { showQuickCart } = catalog;
  const { current, confirmationStatus, currentAddSuccess, loading } = orders;
  const { autocompleteData } = clients;
  const { search } = transports;
  const { product } = products;
  const { monthEvents } = appointment;

  return { auth, showQuickCart, order: current, clientsList: autocompleteData, transportList: search, appointmentList: monthEvents, confirmationStatus, product, currentAddSuccess, loading };
};

export default connect(mapStateToProps, {
  setShowQuickCart,
  getCurrentOrder,
  removeItemFromOrder,
  changeItemQuantityFromOrder,
  setDataToOrder,
  saveOrder,
  cancelOrder,
  confirmOrder,
  closeConfirmationCompleteDialog,
  autocompleteMyClients,
  addClientToOrder,
  addItemToOrderFromCode,
  searchTransports,
  addTransportToOrder,
  showItemDetail,
  getProductByCode,
  getMyAppointments
})(withTranslation()(CatalogQuickCartForm));
